export default __webpack_public_path__ + "static/12-994ab37772379c1e560835d2cfa48876.jpg";